export default (url) => () => import(`@/views/${url}.vue`)



// WEBPACK FOOTER //
// ./src/libs/lazyLoading.js